var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClinicalRequests(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95361 7.1395C3.95361 6.54631 4.43449 6.06543 5.02769 6.06543C5.62088 6.06543 6.10176 6.54631 6.10176 7.1395C6.10176 7.7327 5.62088 8.21358 5.02769 8.21358C4.43449 8.21358 3.95361 7.7327 3.95361 7.1395Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17603 7.1395C7.17603 6.54631 7.6569 6.06543 8.2501 6.06543C8.84329 6.06543 9.32417 6.54631 9.32417 7.1395C9.32417 7.7327 8.84329 8.21358 8.2501 8.21358C7.6569 8.21358 7.17603 7.7327 7.17603 7.1395Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3982 7.1395C10.3982 6.54631 10.8791 6.06543 11.4723 6.06543C12.0655 6.06543 12.5463 6.54631 12.5463 7.1395C12.5463 7.7327 12.0655 8.21358 11.4723 8.21358C10.8791 8.21358 10.3982 7.7327 10.3982 7.1395Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.25098C2.30964 2.25098 1.75 2.81062 1.75 3.50098V10.7649C1.75 11.1663 2.07542 11.4917 2.47685 11.4917C3.70671 11.4917 4.7037 12.4887 4.7037 13.7186V14.3481L7.19058 12.1721C7.69188 11.7335 8.33536 11.4917 9.00147 11.4917H13.5C14.1904 11.4917 14.75 10.9321 14.75 10.2417V3.50097C14.75 2.81062 14.1904 2.25098 13.5 2.25098H3ZM0.25 3.50098C0.25 1.98219 1.48122 0.750977 3 0.750977H13.5C15.0188 0.750977 16.25 1.98219 16.25 3.50097V10.2417C16.25 11.7605 15.0188 12.9917 13.5 12.9917H9.00147C8.69869 12.9917 8.4062 13.1016 8.17834 13.301L4.44758 16.5654C4.22611 16.7592 3.91177 16.8056 3.64379 16.684C3.37581 16.5623 3.2037 16.2953 3.2037 16.001V13.7186C3.2037 13.3171 2.87828 12.9917 2.47685 12.9917C1.247 12.9917 0.25 11.9947 0.25 10.7649V3.50098Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalRequests);
export default __webpack_public_path__ + "static/media/clinical-requests.b986d9a20b48bf2ae41401edfe99c76a.svg";
export { ForwardRef as ReactComponent };